// (function () {
//     'use strict';
//
//     angular
//         .module('estadisticas')
//         .factory('GraficoLocalService', GraficoLocalService);
import angular from 'angular';

    /**
     * Servicio para obtener los datos correspondientes a los gráficos
     */
    GraficoLocalService.$inject = ['$q', '$timeout', '$http'];
     export default function GraficoLocalService($q, $timeout, $http) {

        var self = this;
        self.graficos = null;
        self.promesa = null;

        var graficosPredefinidos = [
            {
                'id': 1,
                'titulo': ucfirst(Lang.get('informes.temporal')),
                'tipo': 'line',
                'variable_principal': 'incidencias',
                'variable_agrupacion': 'fecha_dias'
            },
            {
                'id': 2,
                'titulo': ucfirst(Lang.choice('nombres.incidencia', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.usuario', 1),
                'tipo': 'bar',
                'variable_principal': 'incidencias',
                'variable_agrupacion': 'usuario'
            },
            {
                'id': 3,
                'titulo': ucfirst(Lang.choice('nombres.incidencia', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.origen', 1),
                'tipo': 'pie',
                'variable_principal': 'incidencias',
                'variable_agrupacion': 'origen'
            },
            {
                'id': 4,
                'titulo': ucfirst(Lang.choice('nombres.incidencia', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.distrito', 1),
                'tipo': 'pie',
                'variable_principal': 'incidencias',
                'variable_agrupacion': 'distrito'
            },
            {
                'id': 5,
                'titulo': ucfirst(Lang.choice('nombres.incidencia', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.estado', 1),
                'tipo': 'pie',
                'variable_principal': 'incidencias',
                'variable_agrupacion': 'estado'
            },
            {
                'id': 6,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.estado_tecnico', 1),
                'tipo': 'pie',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'estado_estudio'
            },
            {
                'id': 7,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.estado_tarea', 1),
                'tipo': 'pie',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'estado_reparacion'
            },
            {
                'id': 8,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.distrito', 1),
                'tipo': 'pie',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'distrito'
            },
            {
                'id': 9,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.tipo_incidencia', 1),
                'tipo': 'bar',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'tipo_padre'
            },
            {
                'id': 10,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.subtipo_incidencia', 1),
                'tipo': 'bar',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'tipo'
            },
            {
                'id': 11,
                'titulo': ucfirst(Lang.choice('nombres.tarea', 2)) + ' ' + Lang.get('nombres.por') + ' ' + Lang.choice('nombres.entidad_estudio', 1),
                'tipo': 'bar',
                'variable_principal': 'tareas',
                'variable_agrupacion': 'entidad_reparadora'
            }
            // {
            //     'id':13,
            //     'codigo': 'obras-por-barrio',
            //     'nombre': Lang.get('informes.segun', {estado: Lang.choice('nombres.barrio', 1)}),
            //     'titulo': 'Barrio',
            //     'tipo': 'bar',
            //     'variable_principal': 'tareas',
            //     'variable_agrupacion': 'barrio'
            // },
        ];

        function _getGraficos() {
            var defered = $q.defer();
            if (self.graficos == null) {
                if (self.promesa == null) {
                    self.promesa = $http.get(Sigo.url + '/api/v1/graficos');
                }
                self.promesa.then(function (respuesta) {
                    self.graficos = respuesta.data;
                    defered.resolve(angular.copy(self.graficos));
                });
            } else {
                defered.resolve(angular.copy(self.graficos));
            }
            return defered.promise;
        }

        return {
            getGraficos: _getGraficos,
            getGraficoById: function (id) {
                var defered = $q.defer();
                _getGraficos().then(function (graficos) {
                    var grafico = null;
                    graficos.some(function (item) {
                        if (item.id == id) {
                            grafico = angular.copy(item);
                            return true;
                        }
                    });
                    defered.resolve(grafico);
                });

                return defered.promise;
            }
        };
    }

// })();